
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 0C7.165 0 0 7.163 0 16.001c0 8.838 7.165 16.001 16 16.001 8.838 0 16-7.165 16-16C32 7.162 24.838 0 16 0zm6.622 28.064h-4.468l-2.18-3.748-2.197 3.748H9.31l4.416-5.895-4.416-5.894h4.469l2.193 3.38 2.18-3.38h4.469l-4.414 5.894 4.416 5.895zm.145-12.403H18.3l-2.182-3.748-2.194 3.748h-4.47l4.417-5.895L9.454 3.87h4.469l2.194 3.38 2.182-3.38h4.468l-4.416 5.897 4.416 5.895z","fill":"#000"}})])
          )
        }
      }
    